import { render, staticRenderFns } from "./DesmatamentoMapbiomasSad.vue?vue&type=template&id=cb229f74&lang=pug"
import script from "./DesmatamentoMapbiomasSad.vue?vue&type=script&lang=js"
export * from "./DesmatamentoMapbiomasSad.vue?vue&type=script&lang=js"
import style0 from "./DesmatamentoMapbiomasSad.vue?vue&type=style&index=0&id=cb229f74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports